import { RxDashboard } from "react-icons/rx";
import { BsClipboardData } from "react-icons/bs";
import { FiPlusCircle, FiShare2, FiUsers } from "react-icons/fi";
import { MdOutlineCampaign, MdOutlineEuroSymbol, MdOutlineMoodBad, MdOutlinePayments } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { FiUser } from "react-icons/fi";
import { HiOutlineBuildingOffice2, HiOutlineChatBubbleOvalLeftEllipsis } from "react-icons/hi2";
import { ImLab } from "react-icons/im";
import { IoNotificationsOutline, IoSearchOutline, IoShareSocialOutline } from "react-icons/io5";
import { TbSpeakerphone, TbUsers } from "react-icons/tb"
import { FaRegHeart } from "react-icons/fa6";
import { GoPlus, GoShareAndroid } from "react-icons/go";
import { CiSearch } from "react-icons/ci";
import { RiSearchLine } from "react-icons/ri";
import { LuShare2 } from "react-icons/lu";

// export const links = [
//     {
//         title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
//         Icon: RxDashboard,
//         to: "/",
//     },
//     {
//         title: <FormattedMessage id="discovery" defaultMessage={"Discovery"} />,
//         Icon: IoSearchOutline,
//         to: "/discovery",
//     },
//     {
//         title: <FormattedMessage id="campaign" defaultMessage={"Campaign"} />,
//         Icon: MdOutlineCampaign,
//         to: "/campaign",
//     },
//     {
//         title: <FormattedMessage id="my_influencers" defaultMessage={"My Influencers"} />,
//         Icon: TbUsers,
//         to: "/influencers",
//     },
//     {
//         title: <FormattedMessage id="financial_recap" defaultMessage={"Financial Recap"} />,
//         Icon: MdOutlineEuroSymbol,
//         to: "/financial-recap",
//     },
//     {
//         title: <FormattedMessage id="campaign_recap" defaultMessage={"Campaign Recap"} />,
//         Icon: TbSpeakerphone,
//         to: "/campaign-recap",
//     },
//     {
//         title: <FormattedMessage id="influencer_recap" defaultMessage={"Influencer Recap"} />,
//         Icon: FiUser,
//         to: "/influencer-recap",
//     },
//     {
//         title: <FormattedMessage id="profile" defaultMessage={"Profile"} />,
//         Icon: FiUser,
//         to: "/profile",
//     },
//     {
//         title: <FormattedMessage id="subscription" defaultMessage={"Subscription"} />,
//         Icon: MdOutlinePayments,
//         to: "/subscription",
//     },
//     {
//         title: <FormattedMessage id="favorite_influencers" defaultMessage={"Favorite Influencers"} />,
//         Icon: FaRegHeart,
//         to: "/favorite-influencers",
//     },   
// ]


export const links = [
    {
        title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
        Icon: RxDashboard,
        IconType: "",
        to: "/",
    },
    // FIND CREATORS section
    {
        title: <FormattedMessage id="find_creators" defaultMessage={"FIND CREATORS"} />,
        isCategory: true,
    },
    {
        title: <FormattedMessage id="ai_search" defaultMessage={"AI Search"} />,
        Icon: "search",
        IconType: "featherIcon",
        to: "/ai-search",
    },
    {
        title: <FormattedMessage id="shared_lists" defaultMessage={"Shared Lists"} />,
        Icon: "share-2",
        IconType: "featherIcon",
        to: "/discovery",
    },

    // CAMPAIGNS section
    {
        title: <FormattedMessage id="campaigns" defaultMessage={"CAMPAIGNS"} />,
        isCategory: true,
    },
    {
        title: <FormattedMessage id="create_new_campaign" defaultMessage={"Create New Campaign"} />,
        Icon: "plus-circle",
        IconType: "featherIcon",

        to: "/campaign/create",
    },
    {
        title: <FormattedMessage id="my_campaigns" defaultMessage={"My Campaigns"} />,
        Icon: "target",
        IconType: "featherIcon",

        to: "/campaign",
    },

    // ADMINISTRATION section
    {
        title: <FormattedMessage id="administration" defaultMessage={"ADMINISTRATION"} />,
        isCategory: true,
    },
    {
        title: <FormattedMessage id="creator_documents" defaultMessage={"Creator Documents"} />,
        Icon: "file-text",
        IconType: "featherIcon",

        to: "/financial-recap",
    },
    {
        title: <FormattedMessage id="campaign_summary" defaultMessage={"Campaign Summary"} />,
        Icon: "pie-chart",
        IconType: "featherIcon",
        to: "/campaign-recap",
    },
    {
        title: <FormattedMessage id="creator_summary" defaultMessage={"Creator Summary"} />,
        Icon: "bar-chart-2",
        IconType: "featherIcon",
        to: "/influencer-recap",
    },

    // CREATOR MANAGER section
    {
        title: <FormattedMessage id="creator_manager" defaultMessage={"CREATOR MANAGER"} />,
        isCategory: true,
    },
    {
        title: <FormattedMessage id="my_creators" defaultMessage={"My Creators"} />,
        Icon: "users",
        IconType: "featherIcon",

        to: "/influencers",
    },
    {
        title: <FormattedMessage id="add_new_creator" defaultMessage={"Add New Creator"} />,
        Icon: "plus-circle",
        IconType: "featherIcon",

        to: "/influencers?create=true",
    },
    {
        title: <FormattedMessage id="favorites_my_list" defaultMessage={"Favorites: My Lists"} />,
        Icon: "heart",
        IconType: "featherIcon",

        to: "/favorite-influencers",
    },

    // SETTINGS section
    {
        title: <FormattedMessage id="settings" defaultMessage={"SETTINGS"} />,
        isCategory: true,
    },
    {
        title: <FormattedMessage id="profile_account" defaultMessage={"Profile & Account"} />,
        Icon: "user",
        IconType: "featherIcon",

        to: "/profile",
    },
    {
        title: <FormattedMessage id="subscription" defaultMessage={"Subscription"} />,
        Icon: "credit-card",
        IconType: "featherIcon",

        to: "/subscription",
    },

    // SUPPORT section
    {
        title: <FormattedMessage id="support" defaultMessage={"SUPPORT"} />,
        isCategory: true,
    },
    {
        title: <FormattedMessage id="contact_us" defaultMessage={"Contact us at info@influencee.it"} />,
        Icon: HiOutlineChatBubbleOvalLeftEllipsis,
        description: <FormattedMessage id="contact_us_desc" defaultMessage={"Reach out to our team for technical questions, platform support, or general help."} />,
        // to: "/mailto:info@influencee.it"
        href: "mailto:info@influencee.it",
    },
]